<template>
    <v-card>
      <v-card-text>
        <v-row class="bm-0 mb-0 pb-0">
          <v-col cols="12">
            <v-card-subtitle class="ml-2">
              <h2 class="text-uppercase indigo--text">
                {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
              </h2>
              <h4 class="text-uppercase" style="color: #616161">
                {{ currentUser.roles[0].descripcion }}
              </h4>
              <v-divider class="mt-1"/>
            </v-card-subtitle>
          </v-col>
        </v-row>
        <v-toolbar-title style="background-color: #1D2E4B; border-radius: 5px;">
          <div class="text-center my-2 mx-5" style="color: white;">
            <span class="text-uppercase">
              <b>Tocas pendientes de generar evidencia</b>
            </span>
          </div>
        </v-toolbar-title>
        <v-container fluid>
          <v-data-table
            actions
            light
            dense
            :headers="headers"
            :items="listPendientes"
            :loading="loading"
            :items-per-page="itemsPerPage"
            :server-items-length="totalItems"
            loading-text="Cargando... Por favor espere"
            no-data-text="No hay documentos por mostrar"
            hide-default-footer
          >
            <template v-slot:[`item.toca`]="{ item }">
              <span>
                {{ item.apelacion.toca.numero }}/{{ item.apelacion.toca.anio }}
              </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn 
                x-small 
                dark 
                color="pink" 
                class="mr-2 btn-spacing"
                :loading="item === loadingOriginal" 
                @click="showDocument(item), loadingOriginal = item"
                >
                <v-icon small dark class="mr-2">mdi-file</v-icon>
                  Ver&nbsp;&nbsp;original
              </v-btn>
              <v-btn
                x-small
                class="white--text btn-spacing"
                color="#607D8B"
                @click="showFirmantes(item)"
              >
              <v-icon small class="mr-2">mdi-file-document-edit</v-icon>
                Ver&nbsp;&nbsp;firmantes&nbsp; 
              </v-btn>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="totalPages > 1"
              v-model="currentPage"
              :length="totalPages"
              :total-visible="20"
              @input="getDocumentosPendientesDeFirmar()"
              color="#1D2E4B"
            ></v-pagination>
          </div>
        </v-container>
      </v-card-text>
  
      <v-dialog v-if="dialogFirmantes"
        persistent 
        max-width="900px"
        v-model="dialogFirmantes" 
      >
        <Firmantes :documento_id="documento_id" @close="closeFirmantes"/>
      </v-dialog>
    </v-card>
  </template>
  
  <script>
  
    import { mapGetters } from "vuex";
    import Firmantes from "@/components/Firmantes";
  
    export default {
      components: {
        Firmantes
      },
      data(){
        return {
          loadingOriginal: -1,
          dialogFirmantes: false,
          documento_id: '',
          loading: false,
          currentPage: 1,
          totalPages: 0,
          totalItems: 0,
          itemsPerPage: 20,
          listPendientes:[],
          headers: [
            { text: 'TOCA', value: 'toca', sortable: false },
            { text: 'CATEGORIA', value: 'tipo_documento.categoria.nombre', sortable: false },
            { text: 'TIPO DE DOCUMENTO', value: 'tipo_documento.nombre', sortable: false },
            { text: 'ACCIONES', value: 'action', sortable: false },
          ],
        }
      },
      computed: {
        ...mapGetters([
          "currentUser",
        ]),
      },
      mounted() {
        this.getDocumentosPendientesDeFirmar()
      },
      methods:{
        getDocumentosPendientesDeFirmar(){
          this.loading = true
          this.$store.dispatch("GET_DOCUMENTOS",  {url: "/documentos-pendientes-por-firmar?page=" + this.currentPage})
          .then(response => {
              this.loading = false
              this.listPendientes = response.data.data.pendientes.data;
              this.currentPage = response.data.data.pendientes.current_page;
              this.totalPages = response.data.data.pendientes.last_page;
              this.totalItems = response.data.data.pendientes.total;
          })
          .catch(error => {
            console.log(error);
          });
        },
        showDocument(item){
            this.loadingInline = true;
            this.$store.dispatch("GET_FILE_DOC", {url: "documento/" + item.id + "/previo-multifirma"}).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('target' ,'_blank');
                document.body.appendChild(link);
                link.click()
                this.loadingOriginal = -1;
            })
            .catch(error => {
                this.$swal({
                    title: 'Error al descargar el antecedente, verifique la url.',
                    icon: 'error',
                    confirmButtonText: "Aceptar"
                })
                this.loadingInline = -1;
                console.log(error);
            });
        },
        showFirmantes(item){
          this.documento_id = item.id
          this.dialogFirmantes = true
        },
        closeFirmantes () {
          this.dialogFirmantes = false
          this.getDocumentosPendientesDeFirmar()
        },
      }
    }
  </script>
  
  <style>
    @media screen and (max-width: 748px) {
      .btn-spacing {margin: 4px 0;}
    }
    @media screen and (max-width: 540px) {
      .v-toolbar__title {font-size: 1rem!important;}
    }
  </style>
  